import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ 
    name: "StringSepWithEnterOnCamCase",
    standalone: false
})
export class StringSepWithEnter implements PipeTransform {
    transform(string) {
        string = string.split(/\n/);
        return string;
    }
}
